module.exports = __webpack_public_path__ + "img/order-per-hour.cb5c7c4.svg";